module.exports = __webpack_public_path__ + "img/S9015-ST.b05b1e3d.jpg";